
import Utils from './Utils';
import Config from './config/Config';
import Axios from 'axios';

class Session {
    static params = {};
    
    static apiStatus = null;
    
    static callback = [];
    
    static clear() {
        this.params = {
            id: null,
            name: null,
            photo: null,
            email: null,
            isBrand: null,
            hasAPIAccess: null,
            expireDate: null,
            member: null,
            teams: null
        };
    }
    
    static start() {
        this.clear();

        this.checkLogin();
        
        if(this.apiStatus === null) 
        this.startAPIStatusCheck();
    }
    
    static setCallback(callback) {
        this.callback.push(callback);
    }
    
    static callCallbacks() {
        this.callback.map((callback) => { return callback(); });
    }
    
    static set(params) {
        this.params = params;
    }
    
    static checkLogin() {
        Axios.get(Config.backendHost + "me", {withCredentials: true}).then((response) => {
            if(Utils.checkResponse(response)) {
                var data = response.data;
                
                if(data.status === 'success') {
                    data = data.data;
                    
                    this.set(data);
                    
                    this.callCallbacks();
                    return;
                }
            }
            this.clear();
        });
    }
    
    static startAPIStatusCheck() {
        this.checkAPIStatus();
        setInterval(() => { this.checkAPIStatus() }, 20 * (60 * 10000));
    }
    
    static checkAPIStatus() {
        Axios.get(Config.backendHost + "api/status").then((response) => {
            if(Utils.checkResponse(response)) {
                var data = response.data;
                
                if(data.status === 'success') {
                    data = data.data;
                    
                    this.apiStatus = data.status;
                    
                    this.callCallbacks();
                    return;
                }
            }
            this.apiStatus = "";
        }).catch((err) => { this.apiStatus = ""; });
    }
    
    static logout() {
        Axios.post(Config.mainHost + "php/ajax_signin_1581875760.php", {signout: 0}).then(() => {
            this.clear();
            Utils.reloadPage();
        });
    }
    
    static getParams() {
        this.params.isLoggedIn = (this.params.id !== null);
        this.params.apiStatus = this.apiStatus;
        
        return this.params;
    }
}

export default Session;